import { DTOTokenCollectionsListReponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class TokenCollectionsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(designSystemId: string, versionId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/token-collections`,
      DTOTokenCollectionsListReponse
    );
  }
}
